import $ from 'jquery';
import * as BABYLON from 'babylonjs/es6.js'; // solo in fase di produzione
window.$ = $;

import { sceneManager }from './inc/class.scenemanager';
import { ui } from './inc/class.ui';
import {gestoreModuli} from "./inc/class.gestoremoduli";

import Foundation from 'foundation-sites';

$(document).foundation();

/*****************************
 *
 * POLYFILLS
 */

if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (ancestor.matches(s)) return ancestor;
            ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
    };
}

sceneManager.run();


/*****************************
 *
 * AJAX
 */

$(document).ready(function () {
    $('#submitForm').on('submit', function (e) {
        const tempData = gestoreModuli.extractData();
        const data = JSON.stringify(tempData);
        console.log( tempData );
        e.preventDefault();
    });

    $('#tutorial').foundation('open');

    $('#submitForm').on('formvalid.zf.abide', function () {
        const tempData = gestoreModuli.extractData();
        const data = JSON.stringify(tempData);

        let formData = {};
        $.each($(this).serializeArray(), function () {
            formData[this.name] = this.value;
        });

        $.ajax({
            url: window.location.href + 'ajax.php',
            type: 'POST',
            data: {
                formData: formData,
                configData: data
            },
            beforeSend: function() {
              $('.fa-spinner').css('visibility', 'visible');
            },
            success: function (data) {
                if (data.error) {
                    // handle the error
                    throw data.error.msg;
                }
                $('.fa-spinner').css('visibility', 'hidden');
                $('#ajaxWrapper').html('Richiesta inviata con successo.');
            }
        });
    });
});
